<template>
  <div class="guides-references-item">
    <div class="guides-references-item-head">
      <div :class="`guides-references-item-name${isEditMode ? ' active' : ''}`">{{currentName}}</div>
      <el-button size="small" @click="editItem()"><i class="el-icon-edit"></i></el-button>
      <el-button type="danger" size="small" @click="deleteItem()"><i class="el-icon-delete"></i></el-button>
    </div>
    <div class="guides-references-name-edit" v-if="isEditMode">
      <label>
        <el-input v-model="referenceName" autocomplete="off" :disabled="saveReferenceNameInProgress"></el-input>
      </label>
      <el-button type="primary" @click="saveReferenceName()" class="guides-references-name-edit-send" :disabled="saveReferenceNameInProgress || referenceName === currentName">Изменить</el-button>
    </div>
    <div class="guides-references-keywords" v-if="keywordList.length > 0">
      <div class="guides-references-keywords-item" v-for="item of keywordList" :key="item.id">
        <span>{{item.keyword}}{{item.approximation !== '-1' ? ' (' + item.approximation + ')' : ''}}</span>
        <i class="el-icon-delete" @click="deleteKeyword(item.id)" v-if="isEditMode" ></i>
      </div>
    </div>
    <div class="guides-references-keywords stop" v-if="stopWordList.length > 0">
      <div class="guides-references-keywords-item" v-for="item of stopWordList" :key="item.id">
        <span>{{item.keyword}}</span>
        <i class="el-icon-delete" @click="deleteKeyword(item.id)" v-if="isEditMode" ></i>
      </div>
    </div>
    <div class="guides-references-keywords-edit" v-if="isEditMode">
      <div class="guides-references-keywords-edit-row">
        <label>
          <span>Ключевое слово</span>
          <el-input v-model="newKeyword" autocomplete="off" :disabled="saveKeywordInProgress"></el-input>
        </label>
         <label>
          <span>Расстояние</span>
          <el-input v-model="approximation" type="number" autocomplete="off" :disabled="saveKeywordInProgress" ></el-input>
        </label>
        <el-button type="primary" @click="addKeyword()" class="guides-references-keywords-edit-add" :disabled="saveKeywordInProgress">Добавить</el-button>
      </div>
      <div class="guides-references-keywords-edit-row">
        <label>
          <span>Стоп слово</span>
          <el-input v-model="newStopWord" autocomplete="off" :disabled="saveKeywordInProgress"></el-input>
        </label>
        <el-button type="primary" @click="addStopWord()" class="guides-references-keywords-edit-add" :disabled="saveKeywordInProgress">Добавить</el-button>
      </div>
      <el-button size="small" @click="cancelEdit()" class="guides-references-keywords-edit-close">Закрыть</el-button>
    </div>
  </div>
</template>

<script>
  // api
  import {
    getReferenceGetItemKeywordsApi,
    getReferenceAddItemKeywordApi,
    getReferenceRemoveItemKeywordApi,
    getReferenceUpdateItemApi
  } from "../../../../../../api/references";

  export default {
    name: 'ReferenceItem',
    props: {
      referenceItem: {
        type: Object
      },
      activeEditItemId: {
        type: Number
      }
    },
    data() {
      return {
        keywordList: [],
        newKeyword: '',
        stopWordList: [],
        newStopWord: '',
        approximation: '',
        referenceName: '',
        currentName: '',
        isEditMode: false,
        saveKeywordInProgress: false,
        saveReferenceNameInProgress: false
      };
    },
    methods: {
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
      deleteItem() {
        this.$emit("onDeleteItem", this.referenceItem.id);
      },
      editItem() {
        this.$emit("onEditItem", this.referenceItem.id);
      },
      cancelEdit() {
        this.newKeyword = '';
        this.$emit("onCancelEditItem");
      },
      deleteKeyword(id) {
        getReferenceRemoveItemKeywordApi({ reference_item_keyword_id: id }).then(() => {
          this.loadKeywords();
        });
      },
      loadKeywords() {
        getReferenceGetItemKeywordsApi({ reference_item_id: this.referenceItem.id }).then((resp) => {
          this.keywordList = resp.data.filter(item => item.keyword !== '' && item.is_stop === '0');
          this.stopWordList = resp.data.filter(item => item.keyword !== '' && item.is_stop === '1');
        });
      },
      saveReferenceName() {
        if (this.referenceName === '' || this.referenceName === this.referenceItem.keyword) {
          return
        }

        this.saveReferenceNameInProgress = false

        const params = {
          reference_id: this.referenceItem.reference_id,
          item_id: this.referenceItem.id,
          keyword: this.referenceName,
          group_id: this.referenceItem.group_id,
        }

        getReferenceUpdateItemApi(params).then(() => {
          this.currentName = this.referenceName
          this.saveReferenceNameInProgress = false
        })
      },
      addKeyword() {
        if (this.newKeyword === '') {
          return
        }

        this.saveKeywordInProgress = true;

        const params = {
          reference_item_id: this.referenceItem.id,
          keyword: this.newKeyword,
          is_stop: false,
          approximation: this.approximation !== '' ? parseInt(this.approximation) : -1
        }

        getReferenceAddItemKeywordApi(params).then(() => {
          this.newKeyword = '';
          this.approximation = '';
          this.saveKeywordInProgress = false;
          this.loadKeywords();
        });
      },
      addStopWord() {
        if (this.newStopWord === '') {
          return
        }

        this.saveKeywordInProgress = true;

        const params = {
          reference_item_id: this.referenceItem.id,
          keyword: this.newStopWord,
          is_stop: true
        }

        getReferenceAddItemKeywordApi(params).then(() => {
          this.newStopWord = '';
          this.saveKeywordInProgress = false;
          this.loadKeywords();
        });
      },
    },
    watch: {
      activeEditItemId() {
        this.isEditMode = this.activeEditItemId === this.referenceItem.id;
      }
    },
    mounted() {
      this.loadKeywords()
    },
    beforeMount() {
      this.currentName = this.referenceItem.keyword
      this.referenceName = this.referenceItem.keyword
      this.loadKeywords()
    }
  };
</script>

<style>
  .guides-references-item {
    padding: 20px;
    border-bottom: 1px solid #eee;
  }
  .guides-references-item:first-child {
    border-top: 1px solid #eee;
  }
  .guides-references-item-head {
    display: flex;
    align-items: center;
  }
  .guides-references-item-head .el-button--small, .el-button--small.is-round {
    padding: 4px;
  }
  .guides-references-item-name {
    margin: 0 20px 0 0;
  }
  .guides-references-item-name.active {
    font-size: 16px;
    font-weight: 500;
  }
  .guides-references-keywords {
    display: flex;
    flex-wrap: wrap;
  }
  .guides-references-keywords-item {
    background-color: #eee;
    border-radius: 3px;
    padding: 3px 10px;
    margin: 10px 10px 0 0;
  }
  .guides-references-keywords-item i {
    margin-left: 6px;
    cursor: pointer;
  }
  .guides-references-keywords-edit {
    padding: 15px 0 20px;
  }
  .guides-references-keywords-edit-row {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;
  }
  .guides-references-keywords-edit-row label > span {
    display: block;
    margin-bottom: 4px;
  }
  .guides-references-keywords-edit-row label {
    width: 300px;
    margin-right: 10px;
  }
  .guides-references-keywords-edit-row input[type="number"] {
    padding-right: 0;
  }
  .guides-references-keywords-edit-close {
    margin-top: 10px;
  }
  .guides-references-keywords.stop .guides-references-keywords-item {
    background-color: rgb(248, 185, 185);
  }
  .guides-references-name-edit {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .guides-references-name-edit label > span {
    display: block;
    margin-bottom: 4px;
  }
  .guides-references-name-edit label {
    width: 300px;
    margin-right: 10px;
  }
    @media screen and (max-width: 480px) {
    .guides-references-keywords-edit-row {
      display: block;
    }
  }
</style>